var websiteConfig = process.env;
const currentURL = window.location.href
const hostname = new URL(currentURL).hostname
const subdomain = hostname.split('.')[0]
const extractedSubdomain = (() => {
    let postfixToRemove = process.env.REACT_APP_SUB_DOMAIN_POSTFIX
    // Remove protocol and www (if present)
    let currentURL = window.location.href
    let hostname = new URL(currentURL).hostname
    let subdomain = hostname.split('.')[0]
    // Remove postfix from subdomain
    if (postfixToRemove && subdomain.endsWith(postfixToRemove)) {
      subdomain = subdomain.slice(0, -postfixToRemove.length);
    }
    return subdomain;
  })();

  // console.log(process.env, subdomain, extractedSubdomain);
  websiteConfig = {
    "SubDomain": subdomain,
    "extractedSubdomain": extractedSubdomain,
    "SystemUrl": (process.env.REACT_APP_BACKEND_URL+"admin/"),
    "FrontUrl": process.env.REACT_APP_FRONT_URL,
    "BackendUrl": process.env.REACT_APP_BACKEND_URL,
    "allowRequestIntercepts": process.env.REACT_APP_ALLOW_REQUEST_INTERCEPTS,

  }

export default websiteConfig
